import { render, staticRenderFns } from "./rank.vue?vue&type=template&id=68bfbadb&scoped=true&"
import script from "./rank.vue?vue&type=script&lang=js&"
export * from "./rank.vue?vue&type=script&lang=js&"
import style0 from "./rank.vue?vue&type=style&index=0&id=68bfbadb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfbadb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68bfbadb')) {
      api.createRecord('68bfbadb', component.options)
    } else {
      api.reload('68bfbadb', component.options)
    }
    module.hot.accept("./rank.vue?vue&type=template&id=68bfbadb&scoped=true&", function () {
      api.rerender('68bfbadb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/rank/rank.vue"
export default component.exports